export default __webpack_public_path__ + "static/media/male.238b330d.png";